import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import RingersApp from './ringers/RingersApp';
import MusicApp from './music/MusicApp';
import './App.css';

function HomePage() {
  return (
    <div style={{ 
      minHeight: '100vh', 
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '15px',
        padding: '3rem',
        boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
        textAlign: 'center',
        maxWidth: '600px',
        width: '100%'
      }}>
        <h1 style={{
          fontSize: '3rem',
          color: '#333',
          marginBottom: '1rem',
          fontWeight: 'bold'
        }}>
          Hancock Handbells
        </h1>
        
        <p style={{
          fontSize: '1.2rem',
          color: '#666',
          marginBottom: '3rem',
          lineHeight: '1.6'
        }}>
          Welcome to the Hancock Handbells management system
        </p>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '2rem',
          marginTop: '2rem'
        }}>
          <Link to="/ringers" style={{
            display: 'block',
            padding: '2rem',
            background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '10px',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
            boxShadow: '0 10px 20px rgba(79, 172, 254, 0.3)'
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-5px)';
            e.target.style.boxShadow = '0 15px 30px rgba(79, 172, 254, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 10px 20px rgba(79, 172, 254, 0.3)';
          }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '1rem' }}>Ringers</h2>
            <p style={{ fontSize: '1rem', opacity: 0.9 }}>
              Manage handbell ringers, groups, and contact information
            </p>
          </Link>

          <Link to="/music" style={{
            display: 'block',
            padding: '2rem',
            background: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '10px',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
            boxShadow: '0 10px 20px rgba(250, 112, 154, 0.3)'
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-5px)';
            e.target.style.boxShadow = '0 15px 30px rgba(250, 112, 154, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 10px 20px rgba(250, 112, 154, 0.3)';
          }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '1rem' }}>Music</h2>
            <p style={{ fontSize: '1rem', opacity: 0.9 }}>
              Track music library, arrangements, and performance history
            </p>
          </Link>
        </div>

        <div style={{
          marginTop: '2rem',
          display: 'flex',
          justifyContent: 'center'
        }}>
          <Link to="/ringers/maintenance" style={{
            padding: '0.5rem 1rem',
            backgroundColor: '#ffc107',
            color: 'black',
            textDecoration: 'none',
            borderRadius: '5px',
            fontSize: '0.85rem',
            fontWeight: '500',
            transition: 'opacity 0.3s ease'
          }}
          onMouseEnter={(e) => {
            e.target.style.opacity = '0.8';
          }}
          onMouseLeave={(e) => {
            e.target.style.opacity = '1';
          }}>
            Maintenance
          </Link>
        </div>

        <div style={{
          marginTop: '3rem',
          paddingTop: '2rem',
          borderTop: '1px solid #eee',
          fontSize: '0.9rem',
          color: '#999'
        }}>
          <p>Select an application to get started</p>
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/ringers/*" element={<RingersApp />} />
        <Route path="/music/*" element={<MusicApp />} />
      </Routes>
    </Router>
  );
}

export default App;
